module.exports = __webpack_public_path__ + "static/media/wall-ayultai.cf6179c0.jpg";